import 'regenerator-runtime/runtime'
import { spawn } from 'redux-saga/effects'
import { checkforStatisticsDownloadAfterRehydration } from 'sagas/startup'
import { analyticsWatcher } from 'sagas/analytics'

export function* rootSaga() {
  yield spawn(checkforStatisticsDownloadAfterRehydration)
  yield spawn(analyticsWatcher)
}
